export enum ApiCode {
  SUCCESS = 0,

  UNAUTHORIZED = 10001,
}

export type GenericApiResponse = {
  code: ApiCode;
  ok: boolean;
  msg?: string;
};

export type ApiDataResponse<T> = GenericApiResponse & {
  data: T;
};

export type ApiListResponse<T> = GenericApiResponse & {
  list: T[];
};

export type ApiPaginatedListResponse<T> = ApiListResponse<T> & {
  page: {
    pageNum: number;
    pageSize: number;
    total: number;
  };
};

/**
 * @deprecated We are considering removing this type in the future, in favor of directly
 * transforming the included entities to embed them in the data object.
 */
export type WithIncluded<K extends string, T> = {
  data: {
    [key in K]: T[];
  };
};
